import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AngularSplitModule } from 'angular-split';
import { MarkdownModule } from 'ngx-markdown';

import { AppSharedModule } from 'app/app-shared.module';
import { AuthGuardService } from 'app/providers/bridge-api/auth.service';
import { GroupRouteGuardService } from 'app/services/group-route-guard.service';
import { LexDatePipe } from '../../pipes/lex-date.pipe';
import { AddTagsDialogComponent } from './components/add-tags-dialog/add-tags-dialog.component';
import { DocumentDeleteComponent } from './components/document/document-delete/document-delete.component';
import { DocumentListComponent } from './components/document/document-list/document-list.component';

import {
  CardViewQuickActionsPipe,
  ExperienceCardCheckboxPipe,
  ExperienceCardCommentsPipe,
  ExperienceCardMetaDataPipe,
  ExperienceCardSentimentPipe,
  ExperienceCardTitlePipe,
  IsCheckedPipe,
  TitleScorePipe,
  CollectionSectionSeparatorPipe,
} from './components/document/document-list/pipes/index';
import { DocumentScoringMetricsComponent } from './components/document/document-scoring-metrics/document-scoring-metrics.component';
import { DocumentViewComponent } from './components/document/document-view/document-view.component';
import { ConversationalSectionComponent } from './components/document/document-view/sections/conversational-section/conversational-section.component';
import { DefaultSectionComponent } from './components/document/document-view/sections/default-section/default-section.component';
import { SummarySectionComponent } from './components/document/document-view/sections/summary-section/summary-section.component';
import { DocumentViewDialogComponent } from './components/document/document-view-dialog/document-view-dialog.component';
import { DocumentViewWindowComponent } from './components/document/document-view-window/document-view-window.component';
import { EntityEditorComponent } from './components/document/editor/entity-editor/entity-editor.component';
import { SentimentControlComponent } from './components/document/editor/sentiment-control/sentiment-control.component';
import { SentimentEditorComponent } from './components/document/editor/sentiment-editor/sentiment-editor.component';
import { TopicEditorComponent } from './components/document/editor/topic-editor/topic-editor.component';
import { DownloadAsDialogComponent } from './components/download-as-dialog/download-as-dialog.component';
import { RemoveTagsDialogComponent } from './components/remove-tags-dialog/remove-tags-dialog.component';
import { SaveDocumentsToCollectionDialogComponent } from './components/save-to-collection-dialog/save-to-collection-dialog.component';
import { FilterService } from './services/filter.service';
@NgModule({
  imports: [
    SaveDocumentsToCollectionDialogComponent,
    DocumentScoringMetricsComponent,
    ConversationalSectionComponent,
    DefaultSectionComponent,
    SummarySectionComponent,
    AddTagsDialogComponent,
    RemoveTagsDialogComponent,
    MarkdownModule.forRoot(),
    AppSharedModule,
    AngularSplitModule,
    RouterModule.forRoot(
      [
        {
          canActivate: [AuthGuardService, GroupRouteGuardService],
          path: 'groups/:groupId/projects/:projectId/dashboards/:dashboardId/collections/:collectionName/documents/:documentId',
          component: DocumentViewWindowComponent,
        },
      ],
      {}
    ),
  ],
  providers: [
    CardViewQuickActionsPipe,
    IsCheckedPipe,
    LexDatePipe,
    FilterService,
    ExperienceCardCommentsPipe,
    TitleScorePipe,
    ExperienceCardCheckboxPipe,
    ExperienceCardSentimentPipe,
    ExperienceCardTitlePipe,
    ExperienceCardMetaDataPipe,
    CollectionSectionSeparatorPipe,
  ],
  declarations: [
    DocumentListComponent,
    DocumentViewComponent,
    DownloadAsDialogComponent,
    DocumentDeleteComponent,
    DocumentViewDialogComponent,
    DocumentViewWindowComponent,
    SentimentControlComponent,
    EntityEditorComponent,
    TopicEditorComponent,
    SentimentEditorComponent,
    ExperienceCardCommentsPipe,
    TitleScorePipe,
    ExperienceCardCheckboxPipe,
    ExperienceCardSentimentPipe,
    ExperienceCardTitlePipe,
    ExperienceCardMetaDataPipe,
    CardViewQuickActionsPipe,
    IsCheckedPipe,
    CollectionSectionSeparatorPipe,
  ],
  exports: [
    DocumentListComponent,
    DocumentViewComponent,
    DocumentViewDialogComponent,
    DocumentViewWindowComponent,
    DocumentDeleteComponent,
    AddTagsDialogComponent,
    SaveDocumentsToCollectionDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CollectionModule {}
